<template>
  <h1>Profile</h1>
  <div>
    <p>成澤結（なりさわゆう）</p>
    <p>2000.2.26</p>
    <p>慶應義塾大学商学部４年（休学中)</p>
    <div class="profile">
      <p>■ ２０２０年９月〜 不動産系IT企業様にて長期インターンシップ中。</p>
      <p>ホームページのバックエンド開発を行っています。</p>
      <p>
        主な使用技術はPHP(Zend framework)、たまにJavaScript(jQuery)も使います。
      </p>
      <p>
        <a href="https://note.com/kuroneko22/n/ndc26b67fecd8"
          >インタビュー記事</a
        >もあります。よろしければ是非。
      </p>
    </div>
    <div class="profile">
      <p>■ ２０２１年９月〜 ロンドンへ語学留学中です。</p>
    </div>
  </div>
</template>

<style scoped>
h1 {
  padding-bottom: 30px;
}
a {
  font-size: 15px;
}
.profile {
  padding-top: 30px;
}
</style>

